import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators,} from '@angular/forms';
import {MatButton, MatButtonModule} from '@angular/material/button';
import {
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerModule,
    MatDatepickerToggle,
} from '@angular/material/datepicker';
import {
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField, MatFormFieldModule, MatHint, MatLabel} from '@angular/material/form-field';
import {MatInput, MatInputModule} from '@angular/material/input';
import {AccessTokenCompleteComponent} from '@app/admin/access-token-complete/access-token-complete.component';
import {Client, ClientService} from '@app/admin/client.service';
import {UserPickerComponent} from '@app/user-picker/user-picker/user-picker.component';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-access-token-dialog',
    imports: [
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatLabel,
        UserPickerComponent,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatButtonModule,
        MatDatepicker,
        AsyncPipe,
        MatHint,
    ],
    templateUrl: './access-token-dialog.component.html',
    styleUrl: './access-token-dialog.component.scss',
})
export class AccessTokenDialogComponent implements OnInit {
    public client$: Observable<Client>;
    public form: FormGroup;

    constructor(
        private clientService: ClientService,
        private formBuilder: FormBuilder,
        private matDialog: MatDialog,
        public dialogRef: MatDialogRef<AccessTokenDialogComponent>,
    ) {
        // Create a date 30 days from now
        const defaultDate = new Date();
        defaultDate.setDate(defaultDate.getDate() + 30);

        this.form = this.formBuilder.group({
            title: new FormControl('', Validators.required),
            description: new FormControl(''),
            owner: new FormControl(null, Validators.required),
            expires: new FormControl(defaultDate),
        });
    }

    ngOnInit(): void {
        this.client$ = this.clientService.client;
    }

    createToken(client: Client) {
        const value = this.form.value;
        this.clientService
            .createAccessToken(
                client.id,
                value.title,
                value.description,
                value.owner.id,
                value.expires,
            )
            .subscribe((result) => {
                this.matDialog.open(AccessTokenCompleteComponent, {
                    data: result.token,
                    width: '600px',
                });
                this.dialogRef.close();
            });
    }
}
